// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  worldId: __t.u64(),
  name: __t.string(),
  audioAssetId: __t.u64(),
  kind: __t.string(),
  shapeType: __t.string(),
  cx: __t.f32(),
  cy: __t.f32(),
  cz: __t.f32(),
  radius: __t.f32(),
  sx: __t.f32(),
  sy: __t.f32(),
  sz: __t.f32(),
  gain: __t.f32(),
  loop: __t.bool(),
  fadeDuration: __t.f32(),
  priority: __t.i32(),
};
